function checkTel(tel) {
    var reg = /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$|^0\d{2,3}-?\d{7,8}$/;
    if (!reg.test(tel)) {
        return false;
    } else {
        return true;
    }
}
//新增电话号码检查
function checkPhone(phone) {
    var reg = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
    if (!reg.test(phone)) {
        return false;
    } else {
        return true;
    }
}

function checkMail(mail) {
    var reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/
    if (!reg.test(mail)) {
        return false;
    } else {
        return true;
    }
}

function checkMoney(money) {
    var reg = /^\d$/
    if (!reg.test(money)) {
        return false;
    } else {
        return true;
    }
}

function getToday() {
    var d = new Date();
    var y = d.getFullYear();
    var mon = d.getMonth() + 1;
    var day = d.getDate();
    if (mon < 10) {
        mon = "0" + mon
    }
    if (day < 10) {
        day = "0" + day
    }
    var date = y + "-" + mon + "-" + day
    return date
}

function getDays(days) {
    var today = new Date().getTime();
    var timestamp = today + days * 3600 * 24 * 1000
    var d = new Date(timestamp);
    var y = d.getFullYear();
    var mon = d.getMonth() + 1;
    var day = d.getDate();
    if (mon < 10) {
        mon = "0" + mon
    }
    if (day < 10) {
        day = "0" + day
    }
    var date = y + "-" + mon + "-" + day
    return date
}

function fmtDate(timestamp) {
    var d = new Date(timestamp * 1000);
    var y = d.getFullYear();
    var mon = d.getMonth() + 1;
    var day = d.getDate();
    if (mon < 10) {
        mon = "0" + mon
    }
    if (day < 10) {
        day = "0" + day
    }
    var date = y + "-" + mon + "-" + day
    return date
}




export const Exp = {
    checkTel: checkTel,
    checkPhone: checkPhone,
    checkMail: checkMail,
    checkMoney: checkMoney,
    getToday: getToday,
    getDays: getDays,
    fmtDate: fmtDate,
}